class AldenaNavigation extends HTMLElement {
  connectedCallback() {
    this.menuButton = this.querySelector('[data-menu-open]');
    this.drawer = this.querySelector('[data-drawer]');
    this.closeButton = this.querySelector('[data-menu-close]');
    this.panel = this.querySelector('.aldena-drawer__panel');
    this.lastFocused = null;
    this.menuButton?.addEventListener('click', () => this.open());
    this.closeButton?.addEventListener('click', () => this.close());
    this.drawer?.addEventListener('click', (event) => { if (event.target === this.drawer) this.close(); });
    this.addEventListener('keydown', (event) => this.onKeydown(event));
    this.querySelectorAll('.aldena-nav-item__toggle').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.aldena-nav-item');
        const open = item.dataset.open === 'true';
        this.querySelectorAll('.aldena-nav-item[data-open="true"]').forEach((entry) => { entry.dataset.open = 'false'; entry.querySelector('button')?.setAttribute('aria-expanded','false'); });
        item.dataset.open = String(!open);
        button.setAttribute('aria-expanded', String(!open));
      });
    });
  }
  open() {
    this.lastFocused = document.activeElement;
    this.drawer.dataset.open = 'true';
    this.drawer.setAttribute('aria-hidden', 'false');
    this.menuButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('aldena-nav-open');
    this.closeButton.focus();
  }
  close() {
    this.drawer.dataset.open = 'false';
    this.drawer.setAttribute('aria-hidden', 'true');
    this.menuButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('aldena-nav-open');
    this.lastFocused?.focus();
  }
  onKeydown(event) {
    if (event.key === 'Escape' && this.drawer?.dataset.open === 'true') this.close();
    if (event.key !== 'Tab' || this.drawer?.dataset.open !== 'true') return;
    const focusable = [...this.panel.querySelectorAll('a,button,summary')].filter((element) => !element.hasAttribute('disabled'));
    if (!focusable.length) return;
    const first = focusable[0]; const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
}
customElements.define('aldena-navigation', AldenaNavigation);

document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link) return;
  const href = link.getAttribute('href') || '';
  let eventName = '';
  if (href.includes('wa.me')) eventName = 'whatsapp_click';
  else if (href.startsWith('tel:')) eventName = 'phone_click';
  else if (href.startsWith('mailto:')) eventName = 'email_click';
  if (!eventName) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, link_url: href, link_text: link.textContent.trim() });
});

document.addEventListener('focusin', (event) => {
  const form = event.target.closest('form[action*="contact"]');
  if (form && !form.dataset.started) {
    form.dataset.started = 'true';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'quote_form_started', form_id: form.id || 'contact_form' });
  }
});

document.addEventListener('submit', (event) => {
  const form = event.target.closest('form[action*="contact"]');
  if (!form || !form.checkValidity()) return;
  const button = form.querySelector('button[type="submit"]');
  if (!button) return;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  button.textContent = button.dataset.loadingLabel || 'Sending...';
});
